import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { FlyoutSearchComponent } from '../../flyout/flyout-search/flyout-search.component';
import { FlyoutSearchModule } from '../../flyout/flyout-search/flyout-search.module';
// This Module's Components
import { SearchComponent } from './search.component';

@NgModule({
  imports: [CommonModule, FlyoutSearchModule, ModalModule.forRoot()],
  declarations: [SearchComponent],
  exports: [SearchComponent]
})
export class SearchModule {}
